module.exports = __webpack_public_path__ + "static/media/mailIcon.36bf7474.svg";